/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { rendererIconByName, truthyCellRenderer } from '@gh/common-internal-shared';
import { getRouteInitData, NumberTypes } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import { buildNumberColumn, GridDefinitionFactory, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { JobDrawsPaymentScheduleItem } from '../../../resources/job-details-tab';

@Component({
  selector: 'gh-job-details-draws-payment-schedule-subtab',
  template: require('./job-details-draws-payment-schedule-subtab.component.html'),
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
})
export class JobDetailsDrawsPaymentScheduleSubtabComponent implements OnInit {
  @Input() schedule: JobDrawsPaymentScheduleItem[];

  gridDefinition: LayoutBasedGridDefinition;

  constructor(private route: ActivatedRoute,
              private translations: TranslationService,
              private gridDefinitionFactory: GridDefinitionFactory) {
  }

  ngOnInit(): void {
    const { paymentScheduleGridLayout } = getRouteInitData(this.route);

    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased(
      {
        isDeposit: {
          cellRenderer: truthyCellRenderer(rendererIconByName('done')),
        },
        pctDue: buildNumberColumn(NumberTypes.Percents),
        amountDue: buildNumberColumn(NumberTypes.Price),
        amountDueWithGst: buildNumberColumn(NumberTypes.Price),
        isDeductDeposit: {
          cellRenderer: truthyCellRenderer(this.translations.get('lbl_less_deposit_paid')),
        },
      },
      {
        noAutomation: true,
        defaultColDef: {
          sortable: false,
        },
      },
    );
    this.gridDefinition.bind(paymentScheduleGridLayout);
  }
}
